export default __webpack_public_path__ + "static/media/Loincloth of the Forsaken.dd8414ad.jpg";